import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import RenderHTML from '@/components/RenderHTML';
import { Color } from '@/constants/color';
import useNavigateToPage from '@/hooks/useNavigateToPage';
import { Referral } from '@/types/referral';
import Button from '@/ui/components/Button';
import DataList, { DataRow } from '@/ui/components/DataList';
import DualTime from '@/ui/components/DualTime';

import type { Props } from './types';

const ReferralRow = ({ inbound = false, pos, referral, personTimeZone }: Props) => {
  const renderSharedReferralData = (referral: Referral) => {
    return (
      <>
        <DataRow label="Organization">{referral.referred_by_organization?.name}</DataRow>
        <DataRow label="Role of Referrer">{referral.role_of_referrer}</DataRow>
        <DataRow label="Source">{referral.source}</DataRow>
        <DataRow label="UTM Source">{referral.utm_source || 'None'}</DataRow>
        <DataRow label="Referred At">
          <DualTime
            memberTZ={personTimeZone || 'America/New_York'}
            dateTime={new Date(referral.referred_at)}></DualTime>
        </DataRow>
        <DataRow label="Via">{referral.via}</DataRow>
        <DataRow label="Reason" sensitive>
          <RenderHTML html={referral.reason}></RenderHTML>
        </DataRow>
      </>
    );
  };

  const { navigateToEditReferral } = useNavigateToPage();

  if (inbound) {
    return (
      <DataRow label={`Inbound Referral${pos ? ` ${pos}` : ''}`}>
        <DataList>
          {referral.reference_for && (
            <DataRow label="Reference for">
              <Link
                to={`/people/${referral.reference_for.external_links.homebase.id}`}
                className="mp-sensitive text-blue-600">
                {referral.reference_for.first_name} {referral.reference_for.last_name}
              </Link>
            </DataRow>
          )}

          {renderSharedReferralData(referral)}
        </DataList>
      </DataRow>
    );
  }

  return (
    <DataRow
      label={
        <div className="flex items-center gap-2">
          <span>{`Referral${pos ? ` ${pos}` : ''}`}</span>
          <Button
            ariaLabel="Edit Referral"
            className="!py-0 !px-2"
            color={Color.WHITE}
            onClick={() => navigateToEditReferral(referral.id)}
            size="xs"
            title="Edit Referral"
            type="button">
            <FontAwesomeIcon icon={faPencil} />
          </Button>
        </div>
      }>
      <DataList>
        {referral.referred_by && (
          <DataRow label="Referrer">
            <Link
              to={`/people/${referral.referred_by.external_links.homebase.id}`}
              className="mp-sensitive text-blue-600">
              {referral.referred_by.first_name} {referral.referred_by.last_name}
            </Link>
          </DataRow>
        )}
        {renderSharedReferralData(referral)}
      </DataList>
    </DataRow>
  );
};
export default memo(ReferralRow);
